var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayNearMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02945 3 3 7.02936 3 11.9998V21H12C16.9706 21 21 16.9706 21 11.9998C21 7.02936 16.9706 3.00038 12 3.00038",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02945 3 3 7.02936 3 11.9998V21H12C16.9706 21 21 16.9706 21 11.9998C21 7.02936 16.9706 3.00038 12 3.00038V3ZM12 16.4995H7.50019V11.9998C7.50019 9.51477 9.51453 7.50009 12 7.50009C14.4855 7.50009 16.5002 9.51477 16.5002 11.9998C16.5002 14.4852 14.4855 16.4995 12 16.4995Z",
    fill: "#009940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50057 16.4999H7.49981L7.4983 16.4976L7.49981 16.4958V11.9998C7.49981 9.51477 9.51491 7.50009 12 7.50009C13.242 7.50009 14.3669 8.00367 15.1812 8.81754L15.182 8.8183L20.6938 14.3297C20.8924 13.5864 21 12.8058 21 12.0002C21 7.02936 16.9706 3 12.0004 3C7.02944 3 3 7.02936 3 12.0002V20.9996H12.0004L7.50057 16.4999Z",
    fill: "#00CC5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayNearMe);
export default __webpack_public_path__ + "static/media/payNearMe.5d39c48ee345773f80089aad393cf4c2.svg";
export { ForwardRef as ReactComponent };